import {TELEPHONY_CALL_PAIRING_RESOURCES} from '../constants/TELEPHONY_CALL_PAIRING_RESOURCES';
import {TelephonyCallPairingResource} from '../types/TelephonyCallPairingResource';

export const isTelephonyCallPairingResource = (
  resourceId: string
): resourceId is TelephonyCallPairingResource =>
  TELEPHONY_CALL_PAIRING_RESOURCES.some((resource) => resource === resourceId);
